module.exports = __webpack_public_path__ + "static/img/amazonvendords.da7abf30.jpg";